/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Stopwatch — Free with Lap Timer | Toolverse`)
};

const es_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronómetro Online — Gratis con Registro de Vueltas | Toolverse`)
};

const de_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Stoppuhr — Kostenlos mit Rundenzeiten | Toolverse`)
};

const nl_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online Stopwatch — Gratis met Rondetijden | Toolverse`)
};

const fr_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronomètre en ligne — Gratuit avec chronométrage des tours | Toolverse`)
};

const it_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometro Online — Gratuito con Timer Giri | Toolverse`)
};

const pt_br2_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro Online — Grátis com Contagem de Voltas | Toolverse`)
};

const pt_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronómetro Online — Grátis com Contagem de Voltas | Toolverse`)
};

const ja_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインストップウォッチ — 無料のラップタイマー | Toolverse`)
};

const zh_timer_stopwatch_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线秒表 — 免费计圈计时工具 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_meta_title", locale)
	if (locale === "en") return en_timer_stopwatch_meta_title(inputs)
	if (locale === "es") return es_timer_stopwatch_meta_title(inputs)
	if (locale === "de") return de_timer_stopwatch_meta_title(inputs)
	if (locale === "nl") return nl_timer_stopwatch_meta_title(inputs)
	if (locale === "fr") return fr_timer_stopwatch_meta_title(inputs)
	if (locale === "it") return it_timer_stopwatch_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_meta_title(inputs)
	if (locale === "pt") return pt_timer_stopwatch_meta_title(inputs)
	if (locale === "ja") return ja_timer_stopwatch_meta_title(inputs)
	return zh_timer_stopwatch_meta_title(inputs)
};